module.exports = __webpack_public_path__ + "img/img162.8d628d13.png";